const OPENED_BLOB_REVOKE_DELAY_MS = 60_000;

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export function openBlankTab(): Window | null {
  return window.open("", "_blank");
}

export function openBlobInTab(
  blob: Blob,
  openedWindow: Window | null,
): boolean {
  if (!openedWindow || openedWindow.closed) return false;
  const url = URL.createObjectURL(blob);
  openedWindow.opener = null;
  openedWindow.location.href = url;
  window.setTimeout(() => URL.revokeObjectURL(url), OPENED_BLOB_REVOKE_DELAY_MS);
  return true;
}
